// eslint-disable-next-line import/no-anonymous-default-export
export default {
  language_code: "np",
  language_title: "नेपाली",
  welcome_to_connect: "Connect मा स्वागत छ",
  Login: "लग-इन",
  school_login_title: "विद्यालय लग-इन",
  login_btn: "लग-इन",
  sign_up: "साइन अप",
  enter_your_email: "कृपया ईमेल दिनुहोस्",
  enter_your_password: "कृपया पासवर्ड दिनुहोस्",
  school_signup_title: "विद्यालय साइन अप",
  signup_btn: "साइन अप",
  logout: "साइन आउट",
  change_password: "पासवर्ड परिवर्तन गर्नुहोस्",
  current_password: "हालको पासवर्ड दिनुहोस्",
  new_password: "नयाँ पासवर्ड दिनुहोस्",
  confirm_password: "पासवर्ड सुनिश्चित गर्नुहोस्",
  incorrect_password: "गलत पासवर्ड",
  forgot_password: "पासवर्ड बिर्सिनु भयो?",
  valid_password:
    "पासवर्ड कम्तिमा पनि ८ क्यारेक्टर लामो हुनुपर्दछ, सानो अक्षर, ठूलो अक्षर र अंक समावेश गरेको हुनुपर्दछ।",
  login_for_school_only_msg:
    "माफ गर्नुहोस्, यो लग-इन फारम विद्यालयका लागि मात्र रहेको छ।",
  login_for_student_only_msg:
    "माफ गर्नुहोस्, यो लग-इन फारम विद्यार्थीका लागि मात्र रहेको छ।",
  home: "होम पेज",
  School: "विद्यालय",
  Dashboard: "ड्यासबोर्ड",
  blog: "ब्लग",
  Contact: "सम्पर्कका लागि",
  schools: "विद्यालयहरु",
  courses: "पाठ्यक्रमहरु",
  applications: "आवेदनहरू",
  about_us: "हाम्रो बारेमा",
  contact_us: "सम्पर्कका लागि",
  profile: "मेरो प्रोफाइल",
  for_inquiries: "कुनै पनि सोधपुछका लागि",
  inquiry_form: "विद्यार्थी सोधपुछ फारम",
  for_business_inquiries: "बिजनेस सोधपुछको लागि",
  business_inquiry_form: "बिजनेस सोधपुछ फारम",
  submit: "बुझाउछु",
  language: "भाषा",
  view_all: "सबै हेर्नका लागि",
  our_services: "हाम्रा सेवाहरू",
  course_search: "पाठ्यक्रम खोज्नका लागि",
  school_search: "विद्यालय खोज्नका लागि",
  our_other_services: "हाम्रा अन्य सेवाहरू",
  privacy_policy: "प्राइवेसि पोलिसि",
  terms_of_service: "प्रयोगका सर्तहरू",
  page_not_found: "माफ गर्नुहोस्, पेज भेटिएन",
  student_tag_line_heading: "जापानमा अध्ययन र रोजगार!",
  student_tag_line_subheading:
    "तपाईलाई उपयुक्त हुने विशेष वैदेशिक शिक्षा कार्यक्रम छनोट गर्नुहोस्",
  find_best_matched_course: "तपाइँसँग मिल्ने पाठ्यक्रम भेट्नुहोस्",
  recommended_schools_msg: "तपाईंका लागि हाम्रा उत्कृष्ट विद्यालयहरू",
  popular_schools: "लोकप्रिय विद्यालयहरू",
  statistical_facts: "केही तथ्याङ्कहरु",
  courses_listed: "पाठ्यक्रमहरू",
  schools_listed: "विद्यालयहरू",
  no_results_found: "माफ गर्नुहोस्, कुनै पनि जानकारी भेटिएन",
  go_to_home: "होम पेजमा जानका लागि",
  office_address: "कार्यालय ठेगाना",
  read_more: "थप पढ्नका लागि",
  phone_number: "फोन नम्बर",
  something_went_wrong: "केहि समस्या देखिएको छ",
  area: {
    title: "क्षेत्र",
    value: {
      hokkaido: "होक्काइदो",
      tohoku: "तोहोकु",
      kanto: "कान्तो",
      chubu: "च्यूबु",
      kansai: "कान्साइ",
      chugoku: "च्यूगोकु",
      shikoku: "सिकोकु",
      kyushu: "क्यूस्यू",
    },
  },
  course_type: {
    title: "पाठ्यक्रमको प्रकार",
    value: {
      general_japanese: "सामान्य जापानी",
      university_preparation: "विश्वविद्यालय तयारी",
      business_employment: "बिजनेस रोजगारी",
      others: "अन्य",
    },
  },
  course_duration: {
    title: "पाठ्यक्रमको अवधि",
    value: {
      short: "छोटो",
      long: "लामो",
    },
  },
  enrollment_month: {
    title: "भर्ना महिना",
    value: {
      april: "अप्रिल",
      july: "जुलाई",
      october: "अक्टोबर",
      january: "जनवरी",
    },
  },
  japanese_level: {
    title: "जापानी भाषाको स्तर",
    value: {
      beginner: "शुरुआती",
      intermediate: "मध्यम",
      advance: "उच्च",
    },
  },
  course_info: {
    value: {
      course_name: "पाठ्यक्रमको नाम",
      course_outline: "पाठ्यक्रमको आउटलाइन",
      course_description: "पाठ्यक्रमको विवरण",
      applicable_student: "लक्षित विद्यार्थीहरू",
      visa_type: "भिसाको प्रकार",
      beginning_period: "प्रारम्भिक अवधि",
      learning_content: "सिक्ने सामग्री",
      application_period: "आवेदन अवधि",
      curriculum: "पाठ्यक्रम",
      course_goal: "पाठ्यक्रमको लक्ष्य",
      curriculum_description: "पाठ्यक्रम विवरण",
      tuition: "ट्युसन(JPY)",
      screening_fee: "स्क्रीनिङ शुल्क",
      enrollment_fee: "भर्ना शुल्क",
      class_fee: "कक्षा शुल्क",
      facility_fee: "सुविधा शुल्क",
      total: "कुल",
      tuition_fee_notes: "शिक्षा शुल्कबारे नोट",
    },
  },
  school_info: {
    value: {
      school_name: "विद्यालयको नाम",
      school_logo: "विद्यालयको लोगो",
      available_course_type: "उपलब्ध पाठ्यक्रमको प्रकार",
      available_course_length: "उपलब्ध पाठ्यक्रमको अवधि",
      school_introduction: "विद्यालयको परिचय",
      basic_information: "आधारभूत जानकारी",
      location: "ठेगाना",
      nearest_station: "नजिकको स्टेसन",
      phone_number: "फोन नम्बर",
      fax_number: "फ्याक्स नम्बर",
      school_website: "विद्यालयको वेबसाइट",
      email: "इमेल",
      founder: "संस्थापक",
      director: "निर्देशक",
      authorized_date: "अधिकृत मिति",
      establishmentDate: "स्थापना मिति",
      faculty_staff: "संकाय कर्मचारी",
      num_of_faculty_full_time: "संकाय संख्या (पूर्ण-समय)",
      assisstant_for_housing: "आवासको लागि सहायक",
      foreign_speaking_staff:
        "अंग्रेजी/चिनियाँ/कोरियन आदि भाषा प्रयोग गर्न सक्ने कर्मचारीहरू",
      students: "विद्यार्थीहरू",
      quota_of_school: "विद्यालयको कोटा",
      total_num_students: "कुल विद्यार्थी संख्या",
      major_countries_students: "विद्यार्थीहरूका प्रमुख देशहरू",
      grads_this_year: "अपेक्षित स्नातकहरू (यस वर्षको अन्त्य)",
      grads_last_year: "स्नातकहरूको संख्या (गत वर्ष)",
      after_graduation: "स्नातक पछि",
      jlpt_passer: "JLPT परीक्षामा उत्तीर्ण हुने संख्या",
      admission_selection: "भर्ना",
      selection_method: "छनौट विधि",
      application_fee: "आवेदन शुल्क",
      deadline: "म्याद",
      mailing_address: "पत्राचार ठेगाना",
      pr_school: "विद्यालयको पी आर",
      message_from_school: "विद्यालयबाट सन्देश",
      images: "फोटोहरु",
      videos: "भिडियोहरू",
      school_year_calendar: "विद्यालय वर्ष क्यालेन्डर (कार्यक्रम तालिका)",
      scholarship_if_available: "छात्रवृत्ति (यदि उपलब्ध भए)",
      facility: "सुविधा",
    },
  },
  confirm_account_modal_header: "आफ्नो अकाउन्ट पुष्टि गर्नुहोस्",
  confirm_account_modal_body:
    "माफ गर्नुहोस्, लगइन हुन सकेन! कृपया इमेल भेरिफिकेसन प्रयोग गरी पहिले आफ्नो अकाउन्ट पुष्टि गर्नुहोस्।",
  confirm: "पुष्टि गर्नुहोस्",
  cancel: "रद्द गर्नुहोस्",
  email: "इमेल ठेगाना",
  password: "पासवर्ड",
  do_not_have_account: "के तपाईंको अकाउन्ट छैन? ",
  validation_empty_email: "कृपया इमेल ठेगाना भर्नुहोस्",
  validation_empty_password: "कृपया पासवर्ड भर्नुहोस्",
  user_agreement_prefix: "म Connect Study Abroad का ",
  user_agreement_conjunction: " र ",
  user_agreement_postfix: " सँग सहमत छु",
  user_agreement_validation:
    "कृपया प्रयोगका सर्तहरू र गोपनीयता नीतिमा सहमत हुनुहोस्",
  already_have_account: "के तपाईंको पहिले नै अकाउन्ट छ? ",
  verification_code_sent:
    "हामीले इमेल मार्फत पासवर्ड रिसेट कोड पठाएका छौं। आफ्नो पासवर्ड रिसेट गर्न तल भर्नुहोस्।",
  confirm_account: "अकाउन्ट पुष्टि गर्नुहोस्",
  did_not_receive_code: "कोड प्राप्त गर्नुभएन?",
  resend: "पुन: पठाउनका लागि",
  verification_title: "भेरिफिकेसन",
  passwords_do_not_match: "पासवर्डहरू मेल खाएनन्",
  forgot_password_description:
    "तपाईंको इमेल ठेगाना तल भर्नुहोस् र हामी तपाईंको पासवर्ड रिसेटका लागि इमेल पठाउनेछौं",
  reset_password: "पासवर्ड रिसेट",
  password_reset_code_sent:
    "हामीले इमेल मार्फत पासवर्ड रिसेट कोड पठाएका छौं। आफ्नो पासवर्ड रिसेट गर्न तल भर्नुहोस्।",
  code: "कोड",
  onboarding: {
    first_name: "नाम",
    last_name: "थर",
    date_of_birth: "जन्म मिति",
    year: "साल",
    month: "महिना",
    day: "दिन",
    nationality: "राष्ट्रियता",
    start_study_in_japan: "तपाई कहिले जापानमा अध्ययन सुरु गर्न चाहनुहुन्छ?",
    currently_reside_in_japan: "के तपाई हाल जापानमा बस्नुहुन्छ?",
    yes: "हो",
    no: "होइन",
  },
  student_profile: {
    user_picture: "फोटो",
    first_name: "नाम",
    last_name: "थर",
    date_of_birth: "जन्म मिति",
    sex: "लिङ्ग",
    nationality: "राष्ट्रियता",
    place_of_birth: "जन्म स्थान",
    current_address: "हालको ठेगाना",
    current_occupation: "वर्तमान पेशा",
    start_study_in_japan: "तपाई कहिले जापानमा अध्ययन सुरु गर्न चाहनुहुन्छ?",
    currently_reside_in_japan: "के तपाई हाल जापानमा बस्नुहुन्छ?",
  },
  profile_tabs: {
    profile: "प्रोफाइल",
    application_for_admission: "भर्नाको लागि आवेदन",
    documents: "कागजातहरू",
  },
  admission_application_forms: {
    personal_info: "व्यक्तिगत जानकारी",
    passport_info_stay_history: "राहदानी जानकारी/जापानमा बसेको इतिहास",
    family_friend_japan: "जापानमा परिवार र साथी",
    marital_status: "वैवाहिक स्थिति",
    education_background: "शैक्षिक पृष्ठभूमि",
    professional_background: "रोजगार पृष्ठभूमि",
    japanese_study_experience: "जापानी भाषा अध्ययनको अनुभव",
    japanese_proficiency: "जापानी भाषा प्रवीणता",
    plan_after_graduation: "स्नातक पछिको योजना",
    about_sponsor: "आर्थिक सहयोगी / प्रायोजकको बारेमा",
  },
  admission_application_page1: {
    passport_status: "राहदानी स्थिति",
    passport_number: "राहदानी नम्बर",
    passport_expiration_date: "राहदानी समाप्ति मिति",
    passport_issue_date: "राहदानी जारी मिति",
    previous_coe_application: "योग्यता प्रमाणपत्र (COE) को लागि अघिल्लो आवेदन",
    previous_stay_in_japan: "यसअघि जापान बसाइ",
    previous_stay_in_japan_detail: "यसअघि जापान बसाइ (विस्तृत)",
    date_of_entry: "प्रवेश मिति",
    date_of_departure: "प्रस्थान मिति",
    status_of_residence: "भिसाको प्रकार",
    purpose_of_entry: "प्रवेशको उद्देश्य",
    family_or_friend_question: "के जापानमा तपाईको परिवार वा साथी हुनुहुन्छ?",
    family_or_friend_title: "जापानमा परिवार र साथी",
    relationship: "सम्बन्ध",
    name: "पुरा नाम",
    intention_to_reside: "आवेदकसँगै बस्ने मनसाय",
    place_of_employment: "रोजगारी वा विद्यालयको ठेगाना",
    residence_card_number: "रेसिडेन्स कार्ड नम्बर",
    marital_status: "वैवाहिक स्थिति",
    partner_name: "पति/पत्नीको नाम",
  },
  admission_application_page2: {
    educational_background: "शैक्षिक पृष्ठभूमि",
    type_of_school: "विद्यालयको प्रकार",
    name_of_school: "विद्यालयको नाम (आधिकारिक नाम)",
    location_in_detail: "ठेगाना (विस्तृतमा)",
    period_of_attendance: "उपस्थितिको अवधि",
    start_date: "सुरू मिति",
    end_date: "अन्त्य मिति",
    years: "वर्ष",
    professional_career_question: "के तपाईसँग रोजगारीको कुनै अनुभव छ?",
    professional_career_title: "रोजगार अनुभव",
    company_name: "कम्पनीको नाम",
    type_of_job: "रोजगारको प्रकार",
    period_of_employment: "रोजगारीको अवधि",
    japanese_study_experience_question:
      "के तपाईसँग जापानी भाषा अध्ययनको अनुभव छ?",
    japanese_study_experience_title: "जापानी भाषा अध्ययनको अनुभव",
    hours: "घण्टा",
    japanese_proficiency_certification_question:
      "के तपाईंसँग जापानी भाषा प्रवीणताको प्रमाणपत्र छ?",
    japanese_proficiency_certification_title: "जापानी भाषा क्षमता",
    name_of_test: "परीक्षाको नाम",
    experience_of_test: "परीक्षाको अनुभव",
    year_of_test: "परीक्षा वर्ष",
    level: "स्तर",
    score: "प्राप्त गरेको अङ्क",
    plan_after_graduation: "स्नातक पछिको योजना",
    currently_enrolled: "हाल भर्ना गरिएको छ",
    do_you_have_work_experience: "के तपाइँसँग कामको अनुभव छ? - छ- छैन",
    expected_graduation_date: "अपेक्षित स्नातक मिति",
    enrollemnt_period: "नामांकन अवधि (वर्ष)",
    currently_working_company: "म हाल यो कम्पनीमा काम गर्दैछु",
    studied_japanese_institute:
      "के तपाईंले कुनै संस्थानमा जापानी भाषा पढ्नुभएको छ? - छ- छैन",
    not_yet_completed: "अझै पूरा भएको छैन",
  },
  admission_application_page3: {
    sponsor_name: "आर्थिक सहयोगीको नाम",
    sponsor_address: "आर्थिक सहयोगीको ठेगाना",
    sponsor_relationship: "आवेदकसँग आर्थिक सहयोगीको सम्बन्ध",
    sponsor_annual_income: "आर्थिक सहयोगीको वार्षिक आय",
    sponsor_occupation: "आर्थिक सहयोगीको पेशा",
    sponsor_employer: "आर्थिक सहयोगीको रोजगारदाता",
  },
  student_document: {
    application_for_admission: "भर्नाको लागि आवेदन",
    statement_of_reason_title: "विद्यालय भर्ना हुनुको कारणको बयान",
    statement_of_reason_about:
      "(अन्तिम शिक्षा उत्तीर्ण भएपछि ५ वा बढी वर्ष बितिसकेको अवस्थामा)",
    statement_of_advancement_title:
      "जापानी भाषा शिक्षा स्नातक पछिका गतिविधिहरुको बयान",
    statement_of_advancement_about:
      "(अन्तिम भाषा शिक्षा उत्तीर्ण भएपछि ५ वा बढी वर्ष बितिसकेको अवस्थामा)",
    identification_photograph:
      "पहिचान फोटो (5 प्रति)*  साइज (H x W): 4 cm x 3cm",
    passport_or_identification: "पासपोर्ट वा पहिचान कागजातको प्रतिलिपि",
    diploma_of_last_school: "अध्ययन गरेको अन्तिम विद्यालयको डिप्लोमा",
    transcript_of_last_school: "अध्ययन गरेको अन्तिम विद्यालयबाट ट्रान्सक्रिप्ट",
    japanese_language_proficiency: "जापानी भाषा प्रवीणता प्रमाणित गर्ने कागजात",
    employment_certificate_title: "रोजगार प्रमाणपत्र",
    employment_certificate_about: "(तपाईसँग रोजगारी रेकर्ड भएको बेला मात्र)",
    tuberculosis_screening_title: "जापान प्रवेश पूर्व क्षयरोगको जाँच",
    tuberculosis_screening_about:
      "* फिलिपिन्स, भियतनाम, चीन, इन्डोनेसिया, नेपाल र म्यानमारका आवेदकका लागि यो पेश गर्नु आवश्यक छ।",
    financial_support: "आर्थिक सहयोग कागजात (विद्यालयले तोकेको कागजात)",
    supporter_family_members:
      "आर्थिक सहयोगीको परिवारका सदस्यहरूको सूची (विद्यालयले तोकेको कागजात)",
    supporter_family_structure:
      "आर्थिक सहयोगीको पारिवारिक संरचना प्रमाणित गर्ने कागजात",
    supporter_relationship:
      "आर्थिक सहयोगी र आवेदक बीचको सम्बन्ध प्रमाणित गर्ने कागजात",
    certificate_of_deposit: "जम्मा गरिएको रकमको प्रमाणपत्र (ओरिजिनल)",
    supporter_employment: "आर्थिक सहयोगीको रोजगारी प्रमाणित गर्ने कागजात",
    three_years_asset_formation:
      "विगत ३ वर्षको सम्पत्ति निर्माण प्रक्रिया प्रमाणित गर्ने कागजात",
    supporter_three_years_income:
      "आर्थिक सहयोगीको विगत ३ वर्षको आय प्रमाणित गर्ने कागजात",
  },
  save_profile_btn: "प्रोफाइल सेभ गर्नुहोस्",
  date_of_birth: "जन्म मिति",
  nationality: "राष्ट्रियता",
  additional_fee_label: "भर्नापछि अतिरिक्त शुल्क लाग्ने?",
  additional_fee_yes: "लाग्ने",
  additional_fee_no: "नलाग्ने",
  early_application_deadline:
    "प्राप्त आवेदनहरूको संख्याको आधारमा, आवेदनको म्याद योजना भन्दा अगाडी सर्न सक्ने। ",
  notes_for_the_tuition_fee: "शिक्षा शुल्कबारे नोट",
  course_list: "पाठ्यक्रम सूची",
  course_detail: "पाठ्यक्रमको विवरण",
  school_list: "विद्यालय सूची",
  school_detail: "विद्यालयको विवरण",
  go_to_list: "सूचीमा जानका लागि",
  apply: "आवेदन दिनका लागि",
  applied_date: "आवेदन दिईएको मिति",
  application_status: "आवेदनको स्थिति",
  student_top_page: {
    why_japans: {
      why_japan: "जापान नै किन?",
      cost_of_living: "बस्ने र ट्युसनको लागत US, UK, र अष्ट्रेलिया भन्दा कम!",
      various_scholarship: "विभिन्न छात्रवृत्तिहरू उपलब्ध!",
      part_time_during_study:
        "तपाईं अध्ययनको क्रममा पार्टटाइम र स्नातक पछि पूर्ण-समय काम गर्न सक्नुहुनेछ!",
    },
    what_is_csas: {
      what_is_csa: "CSA के हो?",
      platform_directly_match:
        "विद्यालय र विद्यार्थीहरूलाई प्रत्यक्ष रूपमा म्याच गराउने प्लेटफर्म",
      sign_up_free: "नि:शुल्क साइन अप गर्नुहोस्",
    },
    blogs: {
      blog: "Blog",
    },
    why_japans_stat: {
      why_japan: "जापान नै किन?",
      tuition_and_cost_living_japan: "जापानमा ट्युसन र बस्नेको लागत",
      annual_tuition: "वार्षिक ट्युसन शुल्क (US डलर)",
      annual_living: "बस्नका लागि वार्षिक लागत (US डलर)",
    },
    carrers: {
      career_during_study_available:
        "अध्ययनको क्रममा करियर पनि सँगै लान सकिने!",
      partime_job: "पार्टटाइम काम गर्न सकिने ",
      hrs_per_week: "हप्ताको २८ घण्टा",
      while_studying: "अध्ययनको क्रममा",
      work_upto:
        "*विद्यालय बिदाको समयमा, प्रति हप्ता ४० घण्टा सम्म काम गर्न सक्नुहुन्छ!",
    },
    approval_rate_of_working_visas: {
      approval_rate_of_working_visa: "वर्किंग भिसा को उच्च स्वीकृति दर! ",
      career_after_study: "अध्ययनपछि करियर पनि उपलब्ध!",
      number_of_visa_changes:
        "विद्यार्थी भिषाबाट वर्किंग भिसामा परिवर्तनको संख्या",
      by_how_much: "साल २०२० मा, लगभग ",
      eighty_Seven: "८७%",
      approved: "स्वीकृत भएको!",
    },
    grant_type_scholarships: {
      grant_type_scholarship: "अनुदान-प्रकारका छात्रवृत्तिहरू व्यापक रूपमा ",
      available: "उपलब्ध!",
      almost_foreign_students: "जापानमा अध्ययनको लागि",
      for_study_in_japan:
        "लगभग ३०% विदेशी विद्यार्थीहरूले अनुदान प्रकारको छात्रवृत्ति पाउँछन्",
      there_142_scholarship: "जापानी सरकार र प्राइभेट संस्थाहरूद्वारा ",
      japanese_government:
        "१४२ प्रकारका अनुदान-प्रकारका छात्रवृत्तिहरू प्रदान भईरहेको",
      got_scholarship: "२०२१ मा जापानी सरकारबाट",
      government_2021: "१८४० विद्यार्थीहरुले छात्रवृत्ति पाएका",
    },
    connect_study_deliver_support: {
      connect_study_deliver_support_students:
        "Connect Study ABROAD ले विद्यार्थीहरूलाई सपोर्ट प्रदान गर्दछ",
      sign_up_free: "नि:शुल्क साइन अप गर्नुहोस्",
    },
    about_csas: {
      about_csa: "CSA बारे",
      get_support_fulfill_student_life:
        "रोजगार र थप कुराहरूसँगै आफ्नो विद्यार्थी जीवनलाई साकार गर्न समर्थन पाउनुहोस्!",
      information_not_only_schools:
        "CSA ले विद्यालयहरु मात्र नभई छात्रवृत्ति, आवास, पार्ट-टाइम रोजगारहरु र थप जानकारीहरु प्रदान गर्दछ!",
      get_support_for_education:
        "शिक्षा र करियरको लागि समर्थन प्राप्त गर्नुहोस्",
      our_strong_track_supporting:
        "जापानी कम्पनीहरूलाई विश्वभरबाट प्रतिभाहरु रिक्र्युट गर्न मदत गर्दै आईरहेका छौँ, जसले गर्दा तपाइँको अध्ययन पछि करियर सम्भावनालाई फराकिलो बनाउनेछ।",
    },
    our_factss: {
      our_facts: "हाम्रा तथ्यहरू",
      support_for_7yrs:
        "विगत ७ वर्षदेखि जापानमा अध्ययन गर्न चाहने विद्यार्थीहरूको सपनालाई साकार गर्दै आईरहेको छ।",
      seven_yrs: "",
      more_than: "",
      thirteen_thousand: " १३,००० भन्दा बढी विद्यार्थीहरूले",
      used_our_service: " हाम्रो सेवा प्रयोग गर्नुभएको।",
      career_event: "२० भन्दा बढी देशहरूमा क्यारियर इभेन्टहरु आयोजना गरिएको",
      twenty_countries: "",
      pre_covid: " (कोभिड पुर्व). Study abroad इभेन्टहरु",
      ten_countries: " १० ओटा देशहरूमा",
      covid: " (कोभिड पुर्व)",
      supported_around: "",
      four_thousand_Candidates: "करिब ४००० विद्यार्थीहरूलाई",
      job_hunting: " गत वर्ष जापानमा रोजगार खोजीका लागि सपोर्ट गरेका छौँ।",
      registered_users: "हाम्रा दर्ता भएका प्रयोगकर्ताहरू ",
      hundred_forty: " लगभग १४० देशहरूबाट हुनुहुन्छ।",
    },
    facebook_pages: {
      facebook_page: "फेसबुक पेज",
    },
  },
  select_one: "कुनै एक छनौट गर्नुहोस्",
  pre_apply: "पूर्व-आवेदन दिनका लागि",
  tab_exit_heading: "के तपाईंले सेभ गर्नुभयो?",
  tab_exit_description: "सेभ नगरिएका परिवर्तनहरू हराउनेछन्।",
  yes: "हो",
  no: "होइन",
  duplicate_application_msg:
    "तपाईंले यस पाठ्यक्रममा पहिले नै आवेदन दिनुभएको छ।",
  csa_free_minimun_balance:
    "CSA सेवा नि:शुल्क छ। यद्यपि, जापानमा अध्ययन गर्न भिसाको लागि आवेदन दिन तपाइँ वा परिवारको सदस्य को वार्षिक आम्दानीको प्रमाण र न्यूनतम 2 मिलियन JPY को बैंक ब्यालेन्स देखाउनु पर्ने हुन्छ्।",
  required_student_profile_fields:
    "Required Student Profile fields are not filled up",
  redirect_student_profile_page:
    "You will be redirected to Student Profile Page.",
  redirect: "Redirect",
  proceed_with_course_application: "Proceed with Course Application",
  faq: {
    faq1: {
      id: "1",
      title: "CSA भनेको के हो? ",
      description:
        "CSA तपाईं र जापानका विद्यालयहरूसँग सीधै मेल खाने एउटा प्लेटफर्म हो। लग ईन का लागि कुनै शुल्क लाग्नेछैन। जापानमा पढ्नको लागि तपाईले अब एजेन्टहरूलाई फि तिर्नु पर्दैन। तपाईंले आफ्नो प्रोफाइल इनपुट गरेपछि र तपाईंको कागजातहरू अपलोड गरेपछि तपाईंले स्कूलहरूबाट स्काउट प्राप्त गर्न सक्नुहुन्छ! तपाइँको प्रोफाइल भर्न सुरु गर्नुहोस् र तपाइँलाई रुचि भएको विद्यालयहरूमा भर्ना सुरुगर्नुहोस्।",
    },
    faq2: {
      id: "2",
      title: "CSA ले कस्ता प्रकारका सेवाहरू प्रदान गर्दछ?",
      description:
        "तपाईंले CSA मा खोज्न सक्ने केही चीजहरू छन् जस्तै,- विद्यालयहरू खोज्नुहोस् - स्कूलहरूबाट स्काउटहरू पाउनुहोस् - जापानमा बस्नका लागि आवश्यक सहयोगहरु फेला पार्नुहोस् (आवास, सेल फोन प्राप्त गर्न, आदि।) CSA को बारेमा सबै भन्दा राम्रो कुरा यो हो कि हामीले तपाईलाई अध्ययन गर्दा पार्ट-टाइम काम र अध्ययन पछि पूर्ण-समय जागिर प्राप्त गर्न मद्दत गर्न सक्छौं। ",
    },
    faq3: {
      id: "3",
      title: "विद्यालयहरूमा कसरी आवेदन दिने?",
      description:
        "1. Connect study abroad मा दर्ता गर्नुहोस। 2. तपाईलाई रुचि भएको विद्यालय/पाठ्यक्रमहरू फेला पार्नुहोस् ३. ''पूर्व-लागू'' बटनमा क्लिक गर्नुहोस् *तपाईंले जति धेरै प्रोफाइल भर्नुहुन्छ, तपाईंले जति धेरै कागजातहरू अपलोड गर्नुहुन्छ त्यति धेरै विधालय हरु बाट स्काउट पाउने प्रक्रिया सजिलो हुदैँ जान्छ, त्यसैले आफु निश्चित गर्नुहोस। ",
    },
    faq4: {
      id: "4",
      title: "CSA इन्टर्नशिप भनेको के हो?",
      description:
        "यो Fourth Valley Concierge Corporation (कनेक्ट स्टडी एब्रोड चलाउने कम्पनी) द्वारा प्रदान गरिएको प्याकेज कार्यक्रम हो जसले विद्यार्थीहरूलाई जापानमा काम गर्ने अनुभव लिन र उनीहरूलाई आर्थिक रूपमा सहयोग गर्नको लागि जापानमा अध्ययन गर्ने र इन्टर्नशिप गर्ने सहयोग गर्ने गर्दछ। कुनै जापानी भाषा आवश्यक छैन (अंग्रेजी आवश्यक)",
    },
    faq5: {
      id: "5",
      title: "जापानमा कस्तो विद्यालय प्रणाली छ ?",
      description:
        "त्यहाँ लगभग तीन विकल्प छन्। 1. जापानी भाषा स्कूल तपाईले JLPT N5 स्तरबाट जापानमा अध्ययन गर्न सक्नुहुन्छ। तपाईं विश्वभरका मानिसहरूसँग जापानी भाषा अध्ययन गर्न सक्नुहुन्छ। पाठ्यक्रमहरू स्कूलहरू अनुसार फरक हुन्छन्। 2. विश्वविद्यालयहरू (स्नातक, मास्टर, डाक्टर) सामान्यतया, तपाईंले EJU पास गर्न आवश्यक छ। त्यहाँ अंग्रेजी पाठ्यक्रमहरू भएका स्कूलहरू छन् जसले अंग्रेजीमा पनि परीक्षा दिन अनुमति दिन्छ, तर धेरै छैनन्। त्यसोभए, तपाईलाई कम्तिमा JLPT N2 स्तरको जापानी चाहिन्छ। यही कारणले गर्दा धेरैजसो अन्तर्राष्ट्रिय विद्यार्थीहरू पहिले जापानी भाषा स्कूलमा आउँछन् र उच्च डिग्रीमा जान्छन्। 3. व्यावसायिक/प्रशिक्षण विद्यालयहरू तपाईंले जापानमा विशिष्ट क्षेत्रहरू (जस्तै एनिमे, लेखा, IT, खाना पकाउने, आदि) अध्ययन गर्न सक्नुहुन्छ। मूलतः तपाईलाई माथिको JLPT N2 चाहिन्छ र/वा जापानमा ६ महिनाभन्दा बढी अध्ययन गरेको अनुभव छ। विवरणहरूको लागि कृपया यहाँ हेर्नुहोस्",
    },
    faq6: {
      id: "6",
      title: "छात्रावृति कसरि पाउने? ",
      description:
        "जापानमा142 छात्रवृत्तिहरू छन् जुन फिर्ता तिर्न आवश्यक छैन (जानकारी: Jasso) त्यहाँ CSA का विशेष छात्रवृत्तिहरू पनि छन्।  यसलाई CSA को वेवसाईट मा हेर्नुहोस् र तपाईंले मौका नगुमाउनुहोस् भनेर सुनिश्चित गर्नुहोस्! विवरणहरूको लागि, कृपया यहाँ हेर्नुहोस्",
    },
    faq7: {
      id: "7",
      title: "जापानमा अध्ययन गर्न कति खर्च लाग्छ?",
      description:
        "अमेरिका, युरोपको तुलनामा जापानमा अध्ययन गर्नु एकदमै उचित छ! निस्सन्देह, यो व्यक्ति/विद्यालय, पाठ्यक्रम आदि को प्रकार मा निर्भर गर्दछ, तर सामान्यतया यो लगभग 2 मिल, ट्यूशन र जीवन व्यय सहित प्रति वर्ष JPY। यो अमेरिका वा युरोपमा अध्ययनको तुलनामा 1/2 ~ 1/3 हो! तपाईले अध्ययनको क्रममा जापानमा कानूनी रूपमा पार्ट टाईम काम पनि गर्न सक्नुहुन्छ। विवरणहरूको लागि, कृपया यहाँ हेर्नुहोस्",
    },
    faq8: {
      id: "8",
      title:
        "के म अन्तर्राष्ट्रिय विद्यार्थीको रूपमा पार्ट टाईम काम गर्न सक्छु?",
      description:
        "जापानमा, तपाइँलाई प्रति हप्ता 28 घण्टा सम्म काम गर्न अनुमति छ (विद्यालयको छुट्टीको अवधिमा, प्रति हप्ता 40 घण्टा) न्यूनतम घण्टाको ज्याला (टोकियोमा) लगभग 1,000JPY (=9USD) छ, त्यसैले तपाइँ प्रति वर्ष लगभग 1.6 मिल कमाउन सक्नुहुन्छ! जापानमा लगभग 70% अन्तर्राष्ट्रिय विद्यार्थीहरू आफ्नो अध्ययनको लागि आफूलाई सहयोग गर्न अंशकालिक काम गर्छन्। विवरणहरूको लागि, कृपया यहाँ हेर्नुहोस्",
    },
    faq9: {
      id: "9",
      title: "मैले जापानमा कसरी जागिर पाउन सक्छु?",
      description:
        "जापानमा काम गर्ने विदेशीहरूको संख्या १० वर्षमा ३ गुणा बढेको छ (र विदेशीहरूलाई काममा राख्ने कम्पनीहरूको संख्या पनि बढ्दै गएको छ) त्यसैले यसको मतलब तपाईंले जापानमा काम खोज्ने सम्भावना बढ्दै गएको छ। निस्सन्देह हामीले व्यक्ति र परिस्थिति अनुसार फरक-फरक सल्लाह दिन आवश्यक छ, तर के सामान्य छ कि तपाईलाई कुनै पनि क्षेत्रमा जापानी भाषाको निश्चित स्तर चाहिन्छ। न्यूनतम N4 हो, तर तपाईं जापानी भाषामा जति बढी बुझ्नुहुन्छ, तपाईंले त्यति नै धेरै सम्भावनाहरू पाउनुहुनेछ। हामी जापानमा पनि जागिर पाउन चाहनेहरूलाई समर्थन गर्दैछौं, त्यसैले कृपया रोजगारीका अवसरहरूका लागि यी प्लेटफर्महरूमा पनि हेर्नुहोस्।",
    },
    faq10: {
      id: "10",
      title: "म जापानमा स्नातक डिग्री / मास्टर डिग्री हासिल गर्न चाहन्छु",
      description:
        "CSA मा स्नातक डिग्री र मास्टर डिग्रीहरू बारे जानकारी थप्न बाँकी छ। यदि तपाईं स्नातक डिग्री/मास्टर्स डिग्री बुझ्न चाहनुहुन्छ भने, कृपया https://www.jpss.jp/ja/ मा जाँच गर्नुहोस्",
    },
  },
  required_student_profile_fields: "आवश्यक फिल्डहरू खाली छन्",
  redirect_student_profile_page: "तपाईंलाई विद्यार्थी प्रोफाइल पेजमा लगिनेछ।",
  redirect: "हुन्छ",
  proceed_with_course_application: "पाठ्यक्रमको आवेदनमा जानुहोस्",
};
